import { FORM_NAMES } from "constants/index"
import { vendors as VENDORS } from "config"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Col, Container, Modal, Row } from "reactstrap"
import {
  getCategoryForForm,
  getProductUserTags,
  getTeaserProducts,
  getUserProfile,
  resetCategoryForForm,
  resetProductUserTags,
  resetTeaserProducts,
  resetUserProfile,
  setOrderCheckoutSession,
  submitOrderForm,
} from "store/actions"
import {
  Field,
  formValueSelector,
  initialize,
  reduxForm,
  resetSection,
} from "redux-form"
import {
  AsyncTypeahedSelect,
  MultipleSelectField,
  TextField,
} from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import {
  emailIsValid,
  isRequiredField,
  required,
  shouldDisplayField,
} from "./utils"
import OrderCheckout from "./orderCheckout"
import Cookies from "js-cookie"

const IfoOrderForm = ({
  match,
  getCategoryForForm,
  resetCategoryForForm,
  categoryForForm,
  handleSubmit,
  getTeaserProducts,
  resetTeaserProducts,
  teaserProducts,
  submitOrderForm,
  productUserTags,
  getProductUserTags,
  resetProductUserTags,
  product,
  resetLevel,
  orderCheckoutSession,
  setOrderCheckoutSession,
  getUserProfile,
  userProfile,
  initializeForm,
  resetUserProfile,
  email,
}) => {
  const { identifier } = match?.params
  const vendor_id = VENDORS.IFO_CLIENT_ID
  const [userToken, setUserToken] = useState(null)

  useEffect(() => {
    if (identifier) {
      getCategoryForForm({ identifier, vendor_id })
      getTeaserProducts({ category: identifier, vendor_id: vendor_id })
    }
    setUserToken(Cookies.get("userToken"))
    return () => {
      resetCategoryForForm()
      resetTeaserProducts()
      resetProductUserTags()
      setOrderCheckoutSession(null)
      resetUserProfile()
    }
  }, [])

  useEffect(() => {
    const timeOut = setTimeout(() => {
      getTeaserProducts({
        category: identifier,
        vendor_id: vendor_id,
        ...(!!email ? { email: email } : {}),
      })
      resetLevel()
    }, 300)

    return () => {
      clearTimeout(timeOut)
    }
  }, [email])

  useEffect(() => {
    if (!!userToken) {
      getUserProfile({ token: userToken })
    }
  }, [userToken])

  useEffect(() => {
    if (!!userProfile && !!categoryForForm) {
      let initValues = {}
      categoryForForm?.extra?.form_fields?.forEach(item => {
        if (
          userProfile.hasOwnProperty(item?.name) &&
          !!userProfile[item?.name]
        ) {
          initValues = { ...initValues, [item?.name]: userProfile[item?.name] }
        }
      })
      initializeForm(initValues)
    }
  }, [userProfile, categoryForForm])

  useEffect(() => {
    if (product && product?.value) {
      getProductUserTags({ vendor_id: vendor_id, product_id: product?.value })
    }
  }, [product])

  const formSubmit = data => {
    const { product, ...rest } = data
    submitOrderForm({
      ...rest,
      product_id: product?.id,
      category_identifier: identifier,
      vendor_id: vendor_id,
    })
  }

  return (
    <React.Fragment>
      {!!categoryForForm && categoryForForm?.sold_out && (
        <Modal
          size="md"
          isOpen={categoryForForm?.sold_out}
          scrollable={false}
          centered={true}
        >
          <Row
            className="d-flex justify-content-center"
            style={{ height: "75px" }}
          >
            <Col xs="auto" className="align-self-center">
              <h5>Sorry, we are Sold Out!</h5>
            </Col>
          </Row>
        </Modal>
      )}
      {!!orderCheckoutSession ? (
        <OrderCheckout orderCheckoutSession={orderCheckoutSession} />
      ) : (
        <Container
          fluid
          className="d-flex justify-content-center align-items-ceter col-lg-6"
        >
          <div className="d-flex flex-column p-2 w-100">
            {categoryForForm?.banner_url && (
              <img
                src={categoryForForm?.banner_url}
                style={{ width: "100%" }}
              />
            )}
            {categoryForForm?.file_url && (
              <img src={categoryForForm?.file_url} style={{ width: "100%" }} />
            )}
            <Row className="my-3">
              <Col>
                <Field
                  name="first_name"
                  label={
                    <span>
                      First Name <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="First Name"
                  validate={[required]}
                  component={TextField}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="last_name"
                  label={
                    <span>
                      Last Name <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Last Name"
                  component={TextField}
                  validate={[required]}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col>
                <Field
                  name="email"
                  label={
                    <span>
                      Email <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Email"
                  component={TextField}
                  validate={[required, emailIsValid]}
                />
              </Col>
            </Row>
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "phone"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="phone"
                    label={
                      <span>
                        Phone{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "phone"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Phone"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "phone"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "languages"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="languages"
                    label={
                      <span>
                        Language(s){" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "languages"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Language(s)"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "languages"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "country"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="country"
                    label={
                      <span>
                        Country / Timezone{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "country"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Country / Timezone"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "country"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "city"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="city"
                    label={
                      <span>
                        City{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "city"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="City"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "city"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "state"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="state"
                    label={
                      <span>
                        State{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "state"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="State"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "state"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "location"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="location"
                    label={
                      <span>
                        Location / Travels from{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "location"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Location / Travels from"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "location"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "zip_code"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="zip_code"
                    label={
                      <span>
                        Postal Code{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "zip_code"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Postal Code"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "zip_code"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "business_website"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="business_website"
                    label={
                      <span>
                        Website{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "business_website"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Website"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "business_website"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(categoryForForm?.extra?.form_fields, "bio") && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="bio"
                    label={
                      <span>
                        Bio{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "bio"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Bio"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "bio"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "social_media"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="social_media"
                    label={
                      <span>
                        Social{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "social_media"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Social"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "social_media"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "years_experience"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="years_experience"
                    label={
                      <span>
                        Years Experience{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "years_experience"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Years Experience"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "years_experience"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "area_of_expertise"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="area_of_expertise"
                    label={
                      <span>
                        Area of Expertise{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "area_of_expertise"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Area of Expertise"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "area_of_expertise"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "certifications"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="certifications"
                    label={
                      <span>
                        Certifications{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "certifications"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Certifications"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "certifications"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "fees"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="fees"
                    label={
                      <span>
                        Fees{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "fees"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Fees"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "fees"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "offered_program"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="offered_program"
                    label={
                      <span>
                        Program Offered{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "offered_program"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Program Offered"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "offered_program"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "partial_client_list"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="partial_client_list"
                    label={
                      <span>
                        Partial Client List{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "partial_client_list"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Partial Client List"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "partial_client_list"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "ideal_time_to_meet"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="ideal_time_to_meet"
                    label={
                      <span>
                        Ideal time to meet{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "ideal_time_to_meet"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Ideal time to meet"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "ideal_time_to_meet"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "personal_goal_for_joining_a_forum"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="personal_goal_for_joining_a_forum"
                    label={
                      <span>
                        Personal goal for joining a forum{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "personal_goal_for_joining_a_forum"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Personal goal for joining a forum"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "personal_goal_for_joining_a_forum"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "how_long_have_you_been_a_facilitator"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="how_long_have_you_been_a_facilitator"
                    label={
                      <span>
                        How long have you been a facilitator?{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "how_long_have_you_been_a_facilitator"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="How long have you been a facilitator?"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "how_long_have_you_been_a_facilitator"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "previous_forum_experience"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="previous_forum_experience"
                    label={
                      <span>
                        Previous forum experience{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "previous_forum_experience"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Previous forum experience"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "previous_forum_experience"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "currently_in_a_forum"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="currently_in_a_forum"
                    label={
                      <span>
                        Are you currently in a forum?{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "currently_in_a_forum"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Are you currently in a forum?"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "currently_in_a_forum"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "interested_in_being_a_moderator"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="interested_in_being_a_moderator"
                    label={
                      <span>
                        Would you be interested in being a moderator?{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "interested_in_being_a_moderator"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Would you be interested in being a moderator?"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "interested_in_being_a_moderator"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            {shouldDisplayField(
              categoryForForm?.extra?.form_fields,
              "forum_placement_preference"
            ) && (
              <Row className="my-3">
                <Col>
                  <Field
                    name="forum_placement_preference"
                    label={
                      <span>
                        Forum placement preference{" "}
                        {isRequiredField(
                          categoryForForm?.extra?.form_fields,
                          "forum_placement_preference"
                        ) && <span className="text-danger">*</span>}
                      </span>
                    }
                    placeholder="Forum placement preference"
                    component={TextField}
                    validate={
                      isRequiredField(
                        categoryForForm?.extra?.form_fields,
                        "forum_placement_preference"
                      )
                        ? [required]
                        : []
                    }
                  />
                </Col>
              </Row>
            )}
            <Row className="my-3">
              <Col>
                <Field
                  name={"product"}
                  label={
                    <span>
                      Select
                      <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Select"
                  component={AsyncTypeahedSelect}
                  options={teaserProducts?.map(item => ({
                    value: item?.id,
                    label: `${item?.name} ${
                      item?.price > 0 ? ` - $${item?.price}` : ""
                    }`,
                    ...item,
                  }))}
                  validate={[required]}
                />
              </Col>
            </Row>
            {!!productUserTags && productUserTags?.length > 0 && (
              <Row className="my-2">
                <Col>
                  <Field
                    name="tag_ids"
                    placeholder="Select Tag"
                    label={
                      product && product?.user_tags_label
                        ? product?.user_tags_label
                        : "I am a "
                    }
                    component={MultipleSelectField}
                    options={productUserTags?.map(tag => ({
                      label: tag?.tag,
                      value: tag?.id,
                    }))}
                  />
                </Col>
              </Row>
            )}
            <Row className="d-flex justify-content-center">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Join Now"
                  onClick={handleSubmit(formSubmit)}
                />
              </Col>
            </Row>
          </div>
        </Container>
      )}
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.IFO_ORDER_FORM)

const mapStateToProps = state => ({
  categoryForForm: state.ProductsAndSubscriptions.categoryForForm,
  teaserProducts: state.ProductsAndSubscriptions.teaserProducts,
  productUserTags: state.ProductsAndSubscriptions.productUserTags,
  product: selector(state, "product"),
  orderCheckoutSession: state.ProductsAndSubscriptions.orderCheckoutSession,
  userProfile: state.Profile.userProfile,
  email: selector(state, "email"),
})

const mapDispatchToProps = dispatch => ({
  getCategoryForForm: values => dispatch(getCategoryForForm(values)),
  resetCategoryForForm: () => dispatch(resetCategoryForForm()),
  getTeaserProducts: values => dispatch(getTeaserProducts(values)),
  resetTeaserProducts: () => dispatch(resetTeaserProducts()),
  submitOrderForm: values => dispatch(submitOrderForm(values)),
  getProductUserTags: values => dispatch(getProductUserTags(values)),
  resetProductUserTags: () => dispatch(resetProductUserTags()),
  resetLevel: () =>
    dispatch(resetSection(FORM_NAMES.IFO_ORDER_FORM, ...["product"])),
  setOrderCheckoutSession: value => dispatch(setOrderCheckoutSession(value)),
  getUserProfile: values => dispatch(getUserProfile(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.IFO_ORDER_FORM, values)),
  resetUserProfile: () => dispatch(resetUserProfile()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(reduxForm({ form: FORM_NAMES.IFO_ORDER_FORM })(IfoOrderForm)))
